import React from 'react'
import PropTypes from 'prop-types';
import Link from "../Link/Link"

function NavbarList({ locationPathName, menuName, menu, menuNameClass, wrap, onHandleClick }) {
  return (
    <div className={`navbar-list-group ${(wrap) ? 'wrap' : 'nowrap'}`}>
      {(menuName) ? <div className={menuNameClass}>{menuName}</div> : ''}
      <ul className='navbar-list'>
        {menu.map(node => (
          <li
            className={(locationPathName === node.url) ? "navbar-item active" : 'navbar-item'}
            key={node.id}
          >
            <Link
              to={node.url}
              onClick={onHandleClick}
            >
              {node.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

NavbarList.propTypes = {
  locationPathName: PropTypes.string,
  menuName: PropTypes.string,
  menuNameClass: PropTypes.string,
  menu: PropTypes.arrayOf(
    PropTypes.objectOf(PropTypes.string)
  ),
  wrap: PropTypes.bool,
  onHandleClick: PropTypes.func
};

NavbarList.defaultProps = {
  locationPathName: '',
  menuName: '',
  menuNameClass: 'navbar-list-heading',
  menu: [],
  wrap: false,
  onHandleClick: () => { }
};

export default NavbarList
